import { FC, JSX } from 'react'

import { UserAvatar, UserAvatarType } from './Avatar'
import { DeviceList, DeviceListType } from './deviceList/DevicesList'
import { EventList, EventListType } from './EventList'
import { UserExportUsers, UserExportUsersType } from './ExportUsers'
import { LoyaltyReferral, LoyaltyReferralType } from './LoyaltyReferral'
import { OneSignal, OneSignalType } from './OneSignal'
import { UserPlatformCard, UserPlatformCardType } from './PlatformCard'
import { UserProviderCard, UserProviderCardType } from './ProviderCard'
import { UserThirdPartyCard, UserThirdPartyCardType } from './ThirdPartyCard'

export const User: FC &
  UserAvatarType &
  UserPlatformCardType &
  UserThirdPartyCardType &
  EventListType &
  DeviceListType &
  OneSignalType &
  LoyaltyReferralType &
  UserProviderCardType &
  UserExportUsersType = (): JSX.Element => <></>

User.Avatar = UserAvatar
User.PlatformCard = UserPlatformCard
User.ThirdPartyCard = UserThirdPartyCard
User.EventList = EventList
User.DeviceList = DeviceList
User.OneSignal = OneSignal
User.LoyaltyReferral = LoyaltyReferral
User.ExportUsers = UserExportUsers
User.ProviderCard = UserProviderCard
